define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityWpStatusDomain = void 0;
    class FacilityWpStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityWpStatusDomain.Draft, value: "Draft" },
                    { key: FacilityWpStatusDomain.Eoi, value: "EOI" },
                    { key: FacilityWpStatusDomain.ProvisionallyApproved, value: "Provisionally Approved" },
                    { key: FacilityWpStatusDomain.Quoted, value: "Quoted" },
                    { key: FacilityWpStatusDomain.Approved, value: "Approved" },
                    { key: FacilityWpStatusDomain.Claimed, value: "Claimed" },
                    { key: FacilityWpStatusDomain.Completed, value: "Completed" },
                    { key: FacilityWpStatusDomain.NotApproved, value: "Not Approved" },
                    { key: FacilityWpStatusDomain.Withdrawn, value: "Withdrawn" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityWpStatusDomain.Draft] = 0;
                this.KeyIndex[FacilityWpStatusDomain.Eoi] = 1;
                this.KeyIndex[FacilityWpStatusDomain.ProvisionallyApproved] = 2;
                this.KeyIndex[FacilityWpStatusDomain.Quoted] = 3;
                this.KeyIndex[FacilityWpStatusDomain.Approved] = 4;
                this.KeyIndex[FacilityWpStatusDomain.Claimed] = 5;
                this.KeyIndex[FacilityWpStatusDomain.Completed] = 6;
                this.KeyIndex[FacilityWpStatusDomain.NotApproved] = 7;
                this.KeyIndex[FacilityWpStatusDomain.Withdrawn] = 8;
                this.ValueIndex = {};
                this.ValueIndex["Draft"] = 0;
                this.ValueIndex["EOI"] = 1;
                this.ValueIndex["Provisionally Approved"] = 2;
                this.ValueIndex["Quoted"] = 3;
                this.ValueIndex["Approved"] = 4;
                this.ValueIndex["Claimed"] = 5;
                this.ValueIndex["Completed"] = 6;
                this.ValueIndex["Not Approved"] = 7;
                this.ValueIndex["Withdrawn"] = 8;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityWpStatusDomain = FacilityWpStatusDomain;
    Object.defineProperty(FacilityWpStatusDomain, "Draft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityWpStatusDomain, "Eoi", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityWpStatusDomain, "ProvisionallyApproved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityWpStatusDomain, "Quoted", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FacilityWpStatusDomain, "Approved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FacilityWpStatusDomain, "Claimed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(FacilityWpStatusDomain, "Completed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(FacilityWpStatusDomain, "NotApproved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(FacilityWpStatusDomain, "Withdrawn", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(FacilityWpStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
